<template>
  <div class="border-t py-2.5 flex flex-col gap-y-2.5 overflow-y-auto">
    <strong>{{ state.model?.name }}</strong>
    <c_cell title="所属甲方">
      <template #default>
        <text>{{ state.model?.customer?.name }}</text>
        <text class="text-gray-400 text-xs">{{
          state.model?.customer?.number
        }}</text>
      </template>
    </c_cell>
    <c_cell title="款项说明" :value="state.model?.intro" />
    <c_cell title="附件">
      <template #default>
        <c_UploadFile
          :key="state.model?.id"
          :value="state.model?.attachment"
          :showAdd="false"
          :showText="true"
        />
      </template>
    </c_cell>
    <div
      class="py-4 px-2.5 bg-gray-100 grid rounded-lg gap-x-3"
      style="grid-template-columns: 1fr repeat(3, auto)"
    >
      <strong>收款记录</strong>
      <c_cell title="总额">
        <c_money
          :value="state.model?.amount"
          :key="state.model?.amount"
          :prefix="false"
          bold
          color="#000"
        />
      </c_cell>
      <c_cell title="已收">
        <template #default>
          <c_money
            :value="state.model?.collected_amount"
            :key="state.model?.collected_amount"
            :prefix="false"
            color="#080"
          />
        </template>
      </c_cell>
      <c_cell title="欠款">
        <template #default>
          <c_money
            :value="state.model?.uncollected_amount"
            :key="state.model?.uncollected_amount"
            :prefix="false"
          />
        </template>
      </c_cell>
    </div>
    <div>
      <div
        v-for="(item, index) in state.meetingCollectedRecordList"
        :key="item.id"
        class="px-2.5 flex flex-col gap-y-2.5"
        :class="index != 0 ? 'mt-2.5 pt-2.5 border-t' : ''"
      >
        <ul class="flex gap-x-3 items-center">
          <text>{{ item.number }}</text>
          <text>{{ item.add_admin_name }}</text>
          <text style="margin-left: -5px" class="text-xs text-gray-400">{{
            item.add_department_name
          }}</text>
          <li class="flex-1 text-xs text-gray-400">{{ item.create_time }}</li>
          <c_cell title="收款方式" :value="item.d_collect_type_name" />
          <c_cell title="收款金额">
            <template #default>
              <c_money :value="item.amount" :prefix="false" bold />
            </template>
          </c_cell>
        </ul>
        <c_cell title="收款说明" :value="item.intro" />
        <!-- <ul class="flex flex-wrap gap-x-3 gap-y-2" v-if="item.dkkhmc">
          <c_cell
            title="关联到款"
            :value="item.dkkhmc + ' [' + item.dkkhbm + ']'"
          />
          <c_cell title="到款金额">
            <template #default>
              <c_money :value="item.djke" :prefix="false" color="#ffa500" />
            </template>
          </c_cell>
          <c_cell title="认领金额">
            <template #default>
              <c_money
                :value="item.rlje"
                :prefix="false"
                color="#ffa500"
                bold
              />
            </template>
          </c_cell>
        </ul> -->
        <c_cell title="附件2" class="!items-start">
          <template #default>
            <c_UploadFile
              :key="item.id"
              :value="item.attachment"
              :showAdd="false"
              :showText="true"
            />
          </template>
        </c_cell>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { meeting_collected_plan_search } from "@/http/meeting";

export default {
  props: { id: Number },
  setup(props) {
    const state = reactive({});
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      if (props.id) {
        meeting_collected_plan_search(props.id).then((res) => {
          if (res.status == 200) {
            const { meetingCollectedPlan, meetingCollectedRecordList } =
              res.data.data || {};
            state.model = meetingCollectedPlan;
            state.meetingCollectedRecordList = meetingCollectedRecordList;
          }
        });
      }
    };

    return { state };
  },
};
</script>

<style lang="scss" scoped></style>
